import { render, staticRenderFns } from "./ShowMagicModeBlockListButton.vue?vue&type=template&id=b3136342&"
import script from "./ShowMagicModeBlockListButton.vue?vue&type=script&lang=js&"
export * from "./ShowMagicModeBlockListButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports